import React, { FC } from 'react';
import { Switch, Route } from 'react-router-dom';

import { paths } from '../Root/paths';

import Content from '../../components_/Content';

import Tabs from './Tabs';

import NotificationsForm from './Notifications/Form';
import NotificationsList from './Notifications/List';
import ProtectionTypesForm from './ProtectionTypes/Form';
import ProtectionTypesList from './ProtectionTypes/List';
import SecTree from './SecTree/index';
import SecTreePageHeader from './SecTree/SecTreePageHeader';
import RolesForm from './SecTree/Form/Roles';
import Config from './Config';
import Services from './Services';

const Settings: FC = () => {
  return (
    <Switch>
      {/* Формы */}
      <Route
        path={[
          paths.settings.secTree.roles.create,
          paths.settings.secTree.roles.edit(),
          paths.settings.secTree.roles.copy()
        ]}
      >
        <SecTreePageHeader>
          <RolesForm />
        </SecTreePageHeader>
      </Route>
      <Route
        path={[paths.settings.notifications.create, paths.settings.notifications.edit()]}
        component={NotificationsForm}
      />
      <Route
        path={[paths.settings.protectionTypes.create, paths.settings.protectionTypes.edit()]}
        component={ProtectionTypesForm}
      />

      {/* Списки */}
      <Route path={paths.settings.root}>
        <Content title="Настройки">
          <Tabs />
          <Switch>
            <Route exact path={paths.settings.root} component={NotificationsList} />
            <Route
              exact
              path={paths.settings.protectionTypes.root}
              component={ProtectionTypesList}
            />
            <Route path={paths.settings.secTree.root} component={SecTree} />
            <Route exact path={paths.settings.config.root} component={Config} />
            <Route exact path={paths.settings.services.root} component={Services} />
          </Switch>
        </Content>
      </Route>
    </Switch>
  );
};

export default Settings;
